import { AutocompleteProps } from '@mui/material';
import _uniqueId from 'lodash/uniqueId';
import React from 'react';

import {
  LegacyAutocomplete,
  LegacyFieldWrapper,
  LegacyFieldWrapperPropsFragment,
  LegacyMuiTextField,
} from '~/legacy-components/LegacyForms';

type AutocompletePropsPropsFragment<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> = Omit<
  AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
  'renderInput'
>;

export const LegacyAutocompleteField = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>(
  props: LegacyFieldWrapperPropsFragment &
    AutocompletePropsPropsFragment<T, Multiple, DisableClearable, FreeSolo>,
) => {
  const { label, fieldError, required, highlightLabel, ...rest } = props;

  const autoCompleteProps: AutocompletePropsPropsFragment<
    T,
    Multiple,
    DisableClearable,
    FreeSolo
  > = {
    ...rest,
  };

  const fieldId = _uniqueId('legacyInputField-');

  return (
    <LegacyFieldWrapper
      fieldId={fieldId}
      label={label}
      required={required}
      fieldError={fieldError}
      highlightLabel={highlightLabel}
    >
      <LegacyAutocomplete
        {...autoCompleteProps}
        id={fieldId}
        renderInput={(params) => (
          <LegacyMuiTextField {...params} error={!!fieldError} />
        )}
      />
    </LegacyFieldWrapper>
  );
};
